// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--suJl8","number":"a10a3f92e9--number--LaXZY","text":"a10a3f92e9--text--AM281"};